<template>
    <div class='h-dialogContainer'>
      <form id='addDp'>
      <div class='row h-row-inputBox'>
        <div class='col-sm-6 h-col-inputBox'>
          <div>
            <div class='h-inputLit'><span class="h-red-code">* </span>{{this.$t('DeployManagement.environmentName')}}</div>
            <input type="text" name="dpName" :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" v-model="dpName">
          </div>
        </div>
        <div class='col-sm-6 h-col-inputBox'>
          <div>
            <div class='h-inputLit'><span class="h-red-code">* </span>{{this.$t('DeployManagement.dpSoftVersion')}}</div>
            <ejs-dropdownlist id="dpSoftVersion" name="dpSoftVersion" :fields = "fields" :dataSource = "versionItems" :popupHeight= "popupHeight" v-model='dpSoftVersion' :placeholder='dpVersionMark'>
            </ejs-dropdownlist>
          </div>
        </div>
      </div>
        <div class='row h-row-inputBox'>
        <div class='col-sm-6 h-col-inputBox'>
          <div>
            <div class='h-inputLit'><span class="h-red-code">* </span>{{this.$t('DeployManagement.environmentIP')}}</div>
            <input type="text" name="dpIp" :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" v-model="dpIp">
            </div>
        </div>
          <div class='col-sm-6 h-col-inputBox'>
            <div>
              <div class='h-inputLit'><span class="h-red-code">* </span>{{this.$t('DeployManagement.product')}}</div>
              <ejs-dropdownlist id="product" :fields = "fields" :index = "currentIndex" :dataSource = "productItems" :popupHeight= "popupHeight" v-model='product' :enabled="false" :change="getProductVersionList">
              </ejs-dropdownlist>
            </div>
          </div>
        </div>
        <div class='row h-row-inputBox'>
        <div class='col-sm-6 h-col-inputBox'>
          <div>
            <div class='h-inputLit'><span class="h-red-code">* </span>{{this.$t('DeployManagement.environmentPort')}}</div>
            <input type="text" name="dpPort" :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" v-model="dpPort">
          </div>
        </div>
          <div class='col-sm-6 h-col-inputBox'>
            <div>
              <div class='h-inputLit'><span class="h-red-code">* </span>{{this.$t('DeployManagement.productVersion')}}</div>
              <ejs-dropdownlist id="productVersion" :fields = "fields" :dataSource = "productVersionItems" :popupHeight= "popupHeight" v-model='productVersion' :enabled="true" :placeholder='productVersionMark'>
              </ejs-dropdownlist>
            </div>
          </div>
        </div>
        <div class='row h-row-inputBox'>
          <!--<div class='col-sm-6 h-col-inputBox'>
            <div>
              <div class='h-inputLit'>模板形态:</div>
              <ejs-dropdownlist id="deploymentNorm" :fields = "fields" :index = "currentIndex" :dataSource = "templateItems" :popupHeight= "popupHeight" v-model='deploymentNorm' :enabled="true">
              </ejs-dropdownlist>
            </div>
          </div>-->
        <div class="col-sm-12 control-section default-sample h-col-inputBox">
          <div class='h-inputLit'>{{this.$t('DeployManagement.uploadDeployedTemplate')}}</div>
          <div class="control_wrapper" style="margin-left:0px;">
            <ejs-uploader ref="uploadObj" id='defaultfileupload' name="defaultfileupload" :selected="onFileSelect" allowedExtensions=".xml" :multiple="false"
                          :autoUpload='isAuto' :enabled="enabled"></ejs-uploader>
          </div>
        </div>
      </div>
      </form>
    </div>
</template>

<script>
import Vue from 'vue';
import { TextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs';
import { FormValidator } from '@syncfusion/ej2-vue-inputs';
import { EventBus } from '../../../../../plugins/eventBus';

Vue.use(TextBoxPlugin);
Vue.use(UploaderPlugin);
export default {
  name: 'AddDPEnviroment',
  components: {
  },
  data() {
    return {
      dpName: '',
      dpIp: '',
      dpPort: 12176,　// https port
      userName: '',
      password: '',
      product: 2,
      productVersion: '',
      deploymentNorm: 0,
      dpSoftVersion: '',
      dpVersionMark: `${this.$t('DeployManagement.pleaseSelect')}`,
      productVersionMark: `${this.$t('DeployManagement.pleaseSelect')}`,
      versionItems: [
        /* { sizeVal: 0, sizeTxt: '1.0' },
        { sizeVal: 1, sizeTxt: '2.0' },
        { sizeVal: 2, sizeTxt: '3.0' } */
      ],
      productItems: [
        { sizeVal: 0, sizeTxt: '3000' },
        { sizeVal: 1, sizeTxt: '6000' },
        { sizeVal: 2, sizeTxt: 'MCS' },
      ],
      productVersionItems:[],
      templateItems: [
        { sizeVal: 0, sizeTxt: '单机单点' },
        { sizeVal: 1, sizeTxt: '单机集群' },
        { sizeVal: 2, sizeTxt: '单主多从最小规格' },
        { sizeVal: 3, sizeTxt: '单主多从中等规格' },
        { sizeVal: 4, sizeTxt: '单主多从大型规格' },
        { sizeVal: 5, sizeTxt: '双主多从最小规格' },
        { sizeVal: 6, sizeTxt: '双主多从中等规格' },
        { sizeVal: 7, sizeTxt: '双主多从大型规格' }
      ],
      fields: { text: 'sizeTxt', value: 'sizeVal' },
      popupHeight: 200,
      currentIndex: 0,
      /* path: {
        saveUrl: 'http://localhost:8080/lte/ems/env/upload.html',
        removeUrl: 'http://localhost:8080/lte/ems/env/delDeployTemplate.html'
      }, */
      isAuto: true,
      enabled: true,
      validationOption: {
        customPlacement(inputElement, errorElement) {
          errorElement.style.float = 'left';
          inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {
          dpName: {
            required: [true, `${this.$t('DeployManagement.alertRequired')}`],
            regex: [/^(^\S)/, `${this.$t('DeployManagement.noEmptyStart')}`],
            maxLength: [30, `${this.$t('DeployManagement.topoMaxLength')}30`],
          },
          dpSoftVersion: {
            required: [true, `${this.$t('DeployManagement.alertRequired')}`],
          },
          productVersion: {
            required: [true, `${this.$t('DeployManagement.alertRequired')}`],
          },
          dpIp: {
            required: [true, `${this.$t('DeployManagement.alertRequired')}`],
            regex: ['^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$', `${this.$t('Topo.invalidIPAddress')}`],
          },
          dpPort: {
            required: [true, `${this.$t('DeployManagement.alertRequired')}`],
            regex: ['^\\d*$', `${this.$t('DeployManagement.invalidInt')}`],
            range: [[1, 65535], `${this.$t('DeployManagement.inputRangeIllegal')}`],
          }
        }
      }
    };
  },
  methods: {
    onFileSelect(args) {
      const file = args.filesData;
      if (file[0].name.indexOf('.xml') === -1) {
        EventBus.$emit('toast', { type: 'warning', content: `${this.$t('DeployManagement.pleaseFileType')}` });
        return null;
      }
      this.addTemplate();
    },
    addTemplate() {
      const url = '/lte/ems/env/upload';
      const formData = new FormData();
      const uploadFile = document.getElementById('defaultfileupload').files[0];
      formData.append('file', uploadFile);
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        timeout: 60 * 6 * 1000
      };
      this.$loading.showLoadding(this.$t('System.uploadFile'), uploadFile.name);
      this.axios.post(url, formData, config).then(response => {
        if (response['data'].errorCode === 'SUCCESS') {
          EventBus.$emit('success', this.$t('Common.tips.success'));
        } else {
          EventBus.$emit('error', response['data'].errorString);
        }
        this.$loading.hideLoadding();
        // 解决组件添加相同文件不触发onFileSelect bug
        /* const element = document.getElementsByClassName('e-file-remove-btn')[0];
        element.click(); */
      });
    },
    getData() {
      const fileName = (this.$refs.uploadObj.getFilesData().length === 0) ? '' : this.$refs.uploadObj.getFilesData()[0].name;
      return {
        name: this.dpName,
        type: 'DP',
        content: {
          dpIp: this.dpIp,
          dpPort: this.dpPort,
          userName: this.userName,
          password: this.password,
          product: this.product,
          deploymentNorm: this.deploymentNorm,
          dpSoftVersion: this.dpSoftVersion,
          productVersion: this.productVersion
        },
        deploymentTemplate: fileName
      };
    },
    getDpVersionList() {
      const $this = this;
      this.axios.post('/lte/ems/env/getDpVersionList').then(response => {
        if (response.data.errorCode === 'SUCCESS') {
          // EventBus.$emit('success', this.$t('Common.tips.success'));
          if (response.data.resultVal.length > 0) {
            for (let i = 0; i < response.data.resultVal.length; i++) {
              $this.versionItems.push({
                sizeVal: response.data.resultVal[i].displayversion,
                sizeTxt: response.data.resultVal[i].displayversion
              });
            }
            //document.getElementById('dpSoftVersion').value = response.data.resultVal[0].displayversion;
            //this.dpSoftVersion = response.data.resultVal[0].displayversion;
          }
        } else {
          EventBus.$emit('error', response.data.errorString);
        }
      });
    },
    getProductVersionList() {
      const $this = this;
      const params = {
        productType : this.product
      };
      this.axios.post('/lte/ems/env/getProductVersionList', params).then(response => {
        if (response.data.errorCode === 'SUCCESS') {
          // EventBus.$emit('success', this.$t('Common.tips.success'));
          $this.productVersionItems = [];
          if (response.data.resultVal.length > 0) {
            for (let i = 0; i < response.data.resultVal.length; i++) {
              $this.productVersionItems.push({
                sizeVal: response.data.resultVal[i],
                sizeTxt: response.data.resultVal[i]
              });
            }
            //document.getElementById('dpSoftVersion').value = response.data.resultVal[0].displayversion;
            //this.dpSoftVersion = response.data.resultVal[0].displayversion;
          }
        } else {
          EventBus.$emit('error', response.data.errorString);
        }
      });
    },
    bindValidate() {
      this.formObj = new FormValidator('#addDp', this.validationOption);
    },
    validate() {
      const formStatus = this.formObj.validate();
      return formStatus;
    }
  },
  updated() {
    this.bindValidate();
  }
};
</script>
<style scoped>

</style>
